'use client'

export { default } from '../(prerendered)/(story-pages)/error'
